var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function createExpandableTextProvider(dotNetExpandableTextProvider) {
    return new ExpandableTextProvider(dotNetExpandableTextProvider);
}
class ExpandableTextProvider {
    constructor(dotNetExpandableTextProvider) {
        this.dotNetExpandableTextProvider = dotNetExpandableTextProvider;
    }
    initialize(expandableTextId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.isTextOverflowing(expandableTextId);
            window.addEventListener("resize", () => __awaiter(this, void 0, void 0, function* () {
                yield this.isTextOverflowing(expandableTextId);
            }));
        });
    }
    isTextOverflowing(expandableTextId) {
        return __awaiter(this, void 0, void 0, function* () {
            const element = document.getElementById(expandableTextId);
            const isTextOverflowing = element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth || element.clientHeight > 120;
            yield this.dotNetExpandableTextProvider.invokeMethodAsync('OnOverflowFlagChanged', isTextOverflowing);
        });
    }
}
